import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Label, Input, InputGroup } from 'reactstrap';
import { AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import i18n from '../../../i18next';

const POSSIBLE_WORKING_DAYS = {
    validOnMonday: 'Mon',
    validOnTuesday: 'Tue',
    validOnWednesday: 'Wed',
    validOnThursday: 'Thu',
    validOnFriday: 'Fri',
    validOnSaturday: 'Sat',
    validOnSunday: 'Sun'
}

class HeaderAndDays extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preparationTime: {
                id: null,
                fromHour: null,
                fromMinute: null,
                toHour: null,
                toMinute: null,
                validOnMonday: false,
                validOnTuesday: false,
                validOnWednesday: false,
                validOnThursday: false,
                validOnFriday: false,
                validOnSaturday: false,
                validOnSunday: false,
                duration: null,
                maxOrders: null,
                maxValue: null
            },
            isRequired: true
        }
        this.getValue = this.getValue.bind(this);
        this.validateHoursValues = this.validateHoursValues.bind(this);
        this.validateMinutesValues = this.validateMinutesValues.bind(this);
    }

    componentDidMount() {
        if (Object.keys(this.props.preparationTime).length) {
            this.setState({
                preparationTime: this.props.preparationTime,
                isRequired: this.props.isRequired
            });
        }
        POSSIBLE_WORKING_DAYS.validOnMonday = i18n.t('screens:preparationTimes.mon')
        POSSIBLE_WORKING_DAYS.validOnTuesday = i18n.t('screens:preparationTimes.tue')
        POSSIBLE_WORKING_DAYS.validOnWednesday = i18n.t('screens:preparationTimes.wed')
        POSSIBLE_WORKING_DAYS.validOnThursday = i18n.t('screens:preparationTimes.thu')
        POSSIBLE_WORKING_DAYS.validOnFriday = i18n.t('screens:preparationTimes.fri')
        POSSIBLE_WORKING_DAYS.validOnSaturday = i18n.t('screens:preparationTimes.sat')
        POSSIBLE_WORKING_DAYS.validOnSunday = i18n.t('screens:preparationTimes.sun')
    }

    componentDidUpdate(prevProps) {
        if (this.props.preparationTime !== prevProps.preparationTime) {
            this.setState({
                preparationTime: this.props.preparationTime,
                isRequired: this.props.isRequired
            });
        }
    }

    renderDaysHeader() {
        return (
            <Row>
                <div style={{ width: '100%', marginLeft: 15, marginRight: 15, marginBottom: 15, borderBottom: "1px solid rgb(222, 226, 230)" }}>
                    <Label>{i18n.t('screens:preparationTimes.validOnDays')}</Label>
                </div>
            </Row>
        );
    }

    renderDays() {
        return Object.keys(this.state.preparationTime).map((property, index) => {
            if (property.includes('validOn')) {
                const label = POSSIBLE_WORKING_DAYS[property];

                return (
                    <Col key={`dayOfWeekIndex${index}`} xs={3}>
                        <InputGroup>
                            <Label for={property}>{label}</Label>
                            <Input type="checkbox" id={property} name={property} style={{ position: "relative", marginLeft: 10 }}
                                checked={this.props.preparationTime[property]}
                                onChange={this.props.changeCheckBoxState}
                            />
                        </InputGroup>
                    </Col>
                );
            }
        });
    }

    renderFromTo() {

        return (
            <Fragment>
                <Row>
                    <div style={{ width: '100%', marginLeft: 15, marginRight: 15, marginBottom: 15, borderBottom: "1px solid rgb(222, 226, 230)" }}>
                    </div>
                </Row>
                <Row>
                    <Col xs={6}>
                        <Label>{this.props.preparationTime.hasOwnProperty('capacity') ? i18n.t('screens:jobsHistoryScreen.scheduledAt') : i18n.t('screens:preparationTimes.from')}
                            <small style={{ color: 'rgb(169, 169, 169)', paddingLeft: '3px' }}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                        </Label>
                    </Col>
                    {
                        this.props.preparationTime.hasOwnProperty('toHour') &&
                        <Col xs={6}>
                            <Label>{i18n.t('screens:preparationTimes.to')}
                                <small style={{ color: 'rgb(169, 169, 169)', paddingLeft: '3px' }}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                            </Label>
                        </Col>
                    }

                    {
                        this.props.preparationTime.hasOwnProperty('capacity') &&
                        <Col xs={6}>
                            <Label>{i18n.t('screens:systemControlContainer.capacity')}</Label>
                        </Col>
                    }

                    <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                        <AvGroup >
                            <AvInput type="number" id="fromHour" name="fromHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                                value={this.getValue(this.state.preparationTime.fromHour)}
                                min={0} max={23}
                                onKeyPress={(e) => this.validateHoursValues(e)}
                                onChange={this.props.changeState}
                                required={this.props.availabilitySettings ? false : this.state.isRequired} />
                            <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                        </AvGroup>
                    </Col>

                    <div style={{ paddingTop: 10, color: 'rgb(169, 169, 169)' }}>:</div>

                    <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                        {
                            this.props.preparationTime.hasOwnProperty('capacity') &&
                            this.props.fromMinuteSelect
                        }
                        {
                            this.props.preparationTime.hasOwnProperty('capacity') ? null :
                                <AvGroup >
                                    <AvInput type="number" id="fromMinute" name="fromMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                                        value={this.getValue(this.state.preparationTime.fromMinute)}
                                        min={0} max={59}
                                        onKeyPress={(e) => this.validateMinutesValues(e)}
                                        onChange={this.props.changeState}
                                        required={this.props.availabilitySettings ? false : this.state.isRequired} />
                                    <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                                </AvGroup>
                        }

                    </Col>
                    {
                        this.props.preparationTime.hasOwnProperty('toHour') &&
                        <Fragment>
                            <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                                <AvGroup >
                                    <AvInput type="number" id="toHour" name="toHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                                        value={this.getValue(this.state.preparationTime.toHour)}
                                        min={0} max={23}
                                        onKeyPress={(e) => this.validateHoursValues(e)}
                                        onChange={this.props.changeState}
                                        required={this.props.availabilitySettings ? false : this.state.isRequired} />
                                    <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>

                                </AvGroup>
                            </Col>

                            <div style={{ paddingTop: 10, color: 'rgb(169, 169, 169)' }}>:</div>

                            <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                                <AvGroup>
                                    <AvInput type="number" id="toMinute" name="toMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                                        value={this.getValue(this.state.preparationTime.toMinute)}
                                        min={0} max={59} maxlength='2'
                                        onKeyPress={(e) => this.validateMinutesValues(e)}
                                        onChange={this.props.changeState}
                                        required={this.props.availabilitySettings ? false : this.state.isRequired} />
                                    <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                                </AvGroup>
                            </Col>
                        </Fragment>
                    }
                    {
                        this.props.preparationTime.hasOwnProperty('capacity') &&
                        <Col>{this.props.capacitySelect}</Col>
                    }
                </Row>
                {
                    this.props.timeSlotBased &&
                    <Row style={{ marginTop: 5 }}>
                        <Col xs={4}>
                            <Label>{i18n.t('screens:preparationTimes.duration')}</Label>
                        </Col>
                        <Col xs={4}>
                            <Label>{i18n.t('screens:preparationTimes.maxOrders')}</Label>
                        </Col>
                        <Col xs={4}>
                            <Label>{i18n.t('screens:preparationTimes.maxValue')}</Label>
                        </Col>

                        <Col xs={4}>
                            <AvGroup>
                                <AvInput type='number' id='duration' name='duration' placeholder='mm'
                                    value={this.state.preparationTime.duration}
                                    min={0}
                                    onChange={this.props.changeState}
                                    required={this.state.isRequired} 
                                    onKeyPress={(e) => this.validateMinutesValues(e)}/>
                                <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                            </AvGroup>
                        </Col>
                        <Col xs={4}>
                            <AvGroup>
                                <AvInput type='number' id='maxOrders' name='maxOrders'
                                    value={this.state.preparationTime.maxOrders}
                                    min={0}
                                    onChange={this.props.changeState}
                                    disabled={this.state.preparationTime.maxValue}
                                    required={!this.state.preparationTime.maxValue && !this.state.preparationTime.maxOrders} 
                                    onKeyPress={(e) => this.validateMinutesValues(e)}/>
                                <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                            </AvGroup>
                        </Col>
                        <Col xs={4}>
                            <AvGroup>
                                <AvInput type='number' id='maxValue' name='maxValue'
                                    value={this.state.preparationTime.maxValue}
                                    min={0}
                                    onChange={this.props.changeState}
                                    disabled={this.state.preparationTime.maxOrders}
                                    required={!this.state.preparationTime.maxOrders && !this.state.preparationTime.maxValue} 
                                    onKeyPress={(e) => this.validateMinutesValues(e)} />
                                <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                            </AvGroup>
                        </Col>
                    </Row>
                }
            </Fragment>
        );
    }

    validateHoursValues(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }

            if ((e.target.name == 'fromHour' || e.target.name == 'toHour') && inputKeyCode > 51 && inputKeyCode < 48) {
                e.preventDefault();
            }
        }
    }

    validateMinutesValues(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }

    getValue(value) {
        if (value === 0) {
            return '00';
        }

        return value || '';
    }

    render() {

        return (
            <Container style={{ backgroundColor: '#f8f8f8', paddingTop: 10, paddingBottom: 20, border: '1px solid #E9ECEF' }}>
                {this.renderDaysHeader()}
                <Row>
                    {this.renderDays()}
                </Row>
                {this.renderFromTo()}
                {this.props.children}
            </Container>
        );
    }
}

export default HeaderAndDays;


// WEBPACK FOOTER //
// ./src/components/common/operationHours/HeaderAndDays.js